<template>
  <div class="relative w-full">
    <swiper :options="packageOption" class="swiper w-full pb-6 sm:pb-10" v-if="packageData">
      <swiper-slide v-for="(item, index) in packageData" :key="index" class="item cursor-pointer flex flex-col">
        <router-link :to="{ name: 'detail', params: { category: 'package', id: item.id } }" class="mb-2 md:mb-3 lg:mb-4 w-full" aria-label="Package">
          <div class="square-setbook border">
            <div v-if="item.cover !== ''" class="square-img" v-lazy:background-image="{ src: item.cover }"></div>
            <div v-if="item.cover === ''" class="square-img square-img-none"></div>
          </div>
        </router-link>
        <div class="swiper-text text-sm sm:text-base text-center lg:text-left w-full">
          <p class="leading-snug p-0 mb-1 featuredBooks-name text-base textColorBlack whitespace-pre-wrap">{{ item.name }}</p>
          <div class="flex flex-wrap justify-center lg:justify-start">
            <p class="p-0 mb-0 line-through featuredBooks-price text-NotoSansRegular whitespace-no-wrap leading-relaxed">
              <span class="hidden lg:inline-block">原價</span>
              <span class="lg:hidden">NT.</span>
              {{ item.fixed_price }}</p>
            <p class="mx-1 sm:mx-2 featuredBooks-price leading-relaxed">|</p>
            <p class="featuredBooks-newprice leading-relaxed">NT.{{ item.pricing }}</p>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-button-next focus:outline-none cursor-pointer hidden sm:block swiper-button-next-package mt-0 swiper-button-next-index"></div>
    <div class="swiper-button-prev focus:outline-none cursor-pointer hidden sm:block swiper-button-prev-package mt-0 swiper-button-prev-index"></div>
  </div>
</template>

<script>
export default {
  props: {
    packageData: {
      type: Array
    }
  },
  data () {
    return {
      packageOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        watchOverflow: true,
        loop: false,
        autoplay: {
          delay: 5000
        },
        breakpoints: {
          576: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
            autoplay: {
              delay: 5000
            }
          }
        },
        navigation: {
          nextEl: '.swiper-button-next-package',
          prevEl: '.swiper-button-prev-package'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .slider-books {
    h3 {
      font-weight: 700;
    }
    .square-setbook {
      position: relative;
      // width: 100%;
      padding-bottom : 100%;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      background-color: transparent;
      .square-img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 75%;
        padding-bottom : 80%;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
      }
      .square-img-none {
        background-image: url('~@/assets/images/preset_item.png');
      }
      .square-img[lazy=loading] {
        background-image: none !important;
      }
    }
    .swiper-text {
      .featuredBooks-name {
        min-height: 44px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
      }
      .featuredBooks-price {
        font-size: 14px;
        color: #434343;
      }
      .featuredBooks-newprice {
        font-size: 14px;
        color: #e60012;
      }
    }
  }
</style>
